import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import StarIcon from '@mui/icons-material/Star';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
    Collapse,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';

import { Context as AuthContext } from '../../../../api/auth/context';
import { LinkDetails } from '../../../../api/users/types';

import sidebarFavoritesTreeStyles from './sidebarFavoritesTreeStyles';

const SidebarFavoritesTree = () => {
    const classes = sidebarFavoritesTreeStyles();
    const history = useHistory();
    const location = useLocation();
    const [open, setOpen] = useState(true);

    const authContext = useContext(AuthContext);
    const favoriteLinks: LinkDetails[] = authContext?.currUser?.favoriteLinks
        ? (authContext.currUser.favoriteLinks.administration || []).concat(
              authContext.currUser.favoriteLinks.reservations || []
          )
        : [];

    return (
        <div className={classes.container}>
            <ListItem
                button
                onClick={() => setOpen(!open)}
                className={classes.header}
                disableGutters
            >
                <ListItemIcon className={classes.headerIcon}>
                    <StarIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                    primary="Favorites"
                    primaryTypographyProps={{ className: classes.headerText }}
                />
                {favoriteLinks.length > 0 && (
                    open ? (
                        <ExpandLessIcon className={classes.expandIcon} />
                    ) : (
                        <ExpandMoreIcon className={classes.expandIcon} />
                    )
                )}
            </ListItem>
            {favoriteLinks.length === 0 ? (
                <Typography variant="body2" className={classes.emptyText}>
                    No favorites yet. Use the star icon to add pages.
                </Typography>
            ) : (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="nav" dense disablePadding>
                        {favoriteLinks.map((link) => (
                            <ListItem
                                key={link.path}
                                button
                                onClick={() => history.push(link.path)}
                                className={`${classes.item} ${
                                    location.pathname === link.path ? classes.activeItem : ''
                                }`}
                                disableGutters
                            >
                                <ListItemText
                                    primary={link.name}
                                    primaryTypographyProps={{ className: classes.itemText }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            )}
        </div>
    );
};

export default SidebarFavoritesTree;
